// extracted by mini-css-extract-plugin
module.exports = {"sweeepInvoiceTableParser":"SweeepInvoiceTable_sweeepInvoiceTableParser_2im7w","sweeepInvoiceTableTextCell":"SweeepInvoiceTable_sweeepInvoiceTableTextCell_VEvHR"};